module.exports = __webpack_public_path__ + "watermark2.704801b2.png";